"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @deprecated use Link from foundation/Link
 */
export const Link = createSVGIcon(
  <>
    <path
      d="M1.52 8C1.52 6.632 2.632 5.52 4 5.52H6.44C6.85974 5.52 7.2 5.17974 7.2 4.76V4.76C7.2 4.34026 6.85974 4 6.44 4H4C1.792 4 0 5.792 0 8C0 10.208 1.792 12 4 12H6.44C6.85974 12 7.2 11.6597 7.2 11.24V11.24C7.2 10.8203 6.85974 10.48 6.44 10.48H4C2.632 10.48 1.52 9.368 1.52 8ZM4.8 8C4.8 8.44183 5.15817 8.8 5.6 8.8H10.4C10.8418 8.8 11.2 8.44183 11.2 8V8C11.2 7.55817 10.8418 7.2 10.4 7.2H5.6C5.15817 7.2 4.8 7.55817 4.8 8V8ZM12 4H9.56C9.14026 4 8.8 4.34026 8.8 4.76V4.76C8.8 5.17974 9.14026 5.52 9.56 5.52H12C13.368 5.52 14.48 6.632 14.48 8C14.48 9.368 13.368 10.48 12 10.48H9.56C9.14026 10.48 8.8 10.8203 8.8 11.24V11.24C8.8 11.6597 9.14026 12 9.56 12H12C14.208 12 16 10.208 16 8C16 5.792 14.208 4 12 4Z"
      fill="currentColor"
    />
  </>,
  "LinkIcon",
  { viewBox: "0 0 16 16", fill: "none" }
);
